import React, { useCallback, useMemo } from "react";
import CommonNotificationSummary from "components/event-notifications/event-notification-types/CommonNotificationSummary";
import {
  useGetPriorities,
  useGetUsers,
  useGetTeams,
  useGetInvestigations
} from "security-app/hooks/useInvestigationsAPI";
import { usePagination } from "common/contexts";
function CreateInvestigationNotificationSummary({
  notification = {},
  ...restProps
}) {
  var _a, _b;
  const localPagination = usePagination();
  const { investigations } = useGetInvestigations(localPagination);
  const investigationsMap = useMemo(
    () => Object.fromEntries(investigations.map((investigation) => [investigation.id, { label: investigation.name }])),
    [investigations]
  );
  const { users } = useGetUsers(true);
  const { teams } = useGetTeams(true);
  const usersTeamsMap = useMemo(
    () => ({
      ...Object.fromEntries(users.map((user) => [user.id, { label: user.full_name, icon: "user" }])),
      ...Object.fromEntries(teams.map((team) => [team.id, { label: team.name, icon: "users" }]))
    }),
    [users, teams]
  );
  const { priorities } = useGetPriorities(true);
  const getPriorityText = useCallback(
    (value) => {
      var _a2;
      return value ? (_a2 = priorities.find((priority) => priority.priority === value)) == null ? void 0 : _a2.text : "";
    },
    [priorities]
  );
  return /* @__PURE__ */ React.createElement(CommonNotificationSummary, { ...restProps, notification }, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Create a New Investigation for Every Alert"), /* @__PURE__ */ React.createElement("td", null, notification.config.create_new_investigation ? /* @__PURE__ */ React.createElement("em", null, "True") : /* @__PURE__ */ React.createElement("em", null, "False"))), !notification.config.create_new_investigation && /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Investigation"), /* @__PURE__ */ React.createElement("td", null, (_a = investigationsMap[notification.config.investigation_id]) == null ? void 0 : _a.label)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Assign Investigation To"), /* @__PURE__ */ React.createElement("td", null, (_b = usersTeamsMap[notification.config.investigation_assigned_to]) == null ? void 0 : _b.label)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Investigation Priority"), /* @__PURE__ */ React.createElement("td", null, getPriorityText(notification.config.investigation_priority))), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Investigation Status"), /* @__PURE__ */ React.createElement("td", null, notification.config.investigation_status)));
}
export default CreateInvestigationNotificationSummary;
